import { render } from "./RulePath.vue?vue&type=template&id=87db0264&scoped=true"
import script from "./RulePath.vue?vue&type=script&lang=js"
export * from "./RulePath.vue?vue&type=script&lang=js"

import "./RulePath.vue?vue&type=style&index=0&id=87db0264&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-87db0264"]])

export default __exports__